import { render, staticRenderFns } from "./DotsComponent2.vue?vue&type=template&id=1d506c3f&scoped=true&"
import script from "./DotsComponent2.vue?vue&type=script&lang=js&"
export * from "./DotsComponent2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d506c3f",
  null
  
)

export default component.exports